// extracted by mini-css-extract-plugin
export default {"popConfirmTitleContainer":"BulkDeleteButton_popConfirmTitleContainer__l0juE","confirmOverlay":"BulkDeleteButton_confirmOverlay__U+IOF"};